<template>
  <div class="tebodyitem">
    <div class="tebodyitem-header"><span>配置内容</span></div>
  </div>
  <div class="tebodyitem">
    <el-form-item label="退关通知接收邮箱" required>
      <el-input v-model="form.email" clearable placeholder="请输入" />
    </el-form-item>
  </div>
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';
  import { Close, Search, Minus, ArrowDown, CirclePlus, RemoveFilled, CirclePlusFilled } from '@element-plus/icons-vue'
  import ListFilter from '@/components/listFilter';
  import Spagination from '@/components/spagination';
  import * as Request from '@/assets/request'
  import * as CONST from '@/assets/const'
  import moment from 'moment';
  import { ElMessage } from 'element-plus';

  const emits = defineEmits([ 'change' ]);

  const props = defineProps({
    data: {
      type: Object,
      default: null
    }
  });

  const form = ref({})
  watch(() => form.value, () => {
    emits('change', form.value)
  }, { deep: true });

  const init = () => {
    form.value.email = props.data.email
  }
  watch(() => props.data, () => {
    init();
  }, { deep: true });
</script>

<style scoped lang="less">
  @import "./index.less";
</style>